import React from 'react';
import img from '../../image/404-error-with-astronaut-line-galaxy-background_114341-124.jpg'

const Error = () => {
    return (
        <div>
            <img src={img} alt=''/>
        </div>
    );
};

export default Error;